// Filename: src/screens/import/Upload.jsx
// Last Updated: 2025-02-03 18:29:44 UTC
// Author: raghavkunkee

import { RadioButton } from "primereact/radiobutton";
import { useEffect, useState, useContext, useCallback } from "react";
import { subscriberContext } from "../../App";

import importJson from "../../assets/json/import.json";
import AnimePlayer from "../../components/generic/animePlayer";
import FileUploadComponent from "../../components/generic/fileUpload";
import {
  CardNoBackground,
  CardWithBackground,
  StyledCustomCard,
  StyledLabelBlack,
} from "../../components/routing/Styled";
import { fetchWithFallback, defaultOptions } from "../../utils/apiUtils";

/**
 * Upload component for handling import functionality
 * @param {Object} props Component properties
 * @param {Function} props.setActiveTab Function to set the active tab
 * @return {JSX.Element} Rendered component
 */
const Upload = ({ setActiveTab }) => {
  const { keycloak } = useContext(subscriberContext);
  const [request, setRequest] = useState("REFRESH_DATA");
  const [dataType, setDataType] = useState("GROUP_METADATA");
  // const [dataType, setDataType] = useState("GROUP_METADATA_NEW");
  const [marketPlace, setMarketPlace] = useState("A21TJRUUN4KGV");
  const [requestOption, setRequestOption] = useState(defaultOptions.requestTypes);
  const [dataTypeOption, setDataTypeOption] = useState([]);
  const [marketOption, setMarketOption] = useState([]);

  const fetchData = useCallback(async () => {
    // Fetch field groups
    const fieldGroupsUrl = `${process.env.REACT_APP_APIIMPORTURL}/v1/fieldgroups?page=0&size=50&sortby=status&sortOrder=ASC&status=ACTIVE`;
    const defaultFieldGroupsResponse = {
      _embedded: {
        fieldGroupVOList: defaultOptions.dataTypes.map(option => ({
          code: option.value,
          description: option.label
        }))
      }
    };

    const fieldGroupsData = await fetchWithFallback(
      fieldGroupsUrl,
      defaultFieldGroupsResponse,
      {},
      keycloak?.token
    );

    setDataTypeOption(
      fieldGroupsData?._embedded?.fieldGroupVOList?.map(item => ({
        value: item.code,
        label: item.description,
      })) || defaultOptions.dataTypes
    );

    // Fetch marketplaces
    const marketplacesUrl = `${process.env.REACT_APP_APIIMPORTURL}/v1/marketplaces/source/AMZ?page=0&size=25&sortby=status&sortOrder=ASC&status=ACTIVE`;
    const defaultMarketplacesResponse = {
      _embedded: {
        marketplaceVOList: defaultOptions.markets.map(option => ({
          code: option.value,
          country: option.label.split(' (')[0],
          countryCode: option.label.split('(')[1].replace(')', '')
        }))
      }
    };

    const marketplacesData = await fetchWithFallback(
      marketplacesUrl,
      defaultMarketplacesResponse,
      {},
      keycloak?.token
    );

    setMarketOption(
      marketplacesData?._embedded?.marketplaceVOList?.map(item => ({
        value: item.code,
        label: `${item.country}(${item.countryCode})`
      })) || defaultOptions.markets
    );
  }, [keycloak?.token]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Render radio button options
  const reqOption = (option, check, update) => {
    return option.map((req) => (
      <div key={req.value} style={{ fontSize: "12px" }}>
        <RadioButton
          value={req.value}
          name={req.label}
          onChange={(e) => update(e.value)}
          checked={check === req.value}
          className="mt-2 mr-2"
        />
        <span className="text-center">{req.label}</span>
      </div>
    ));
  };

  // Render market options
  const reqMarketOption = (option, check, update) => {
    return option.map((req) => (
      <div style={{ fontSize: "12px" }} key={req.value}>
        <RadioButton
          value={req.value}
          name={req.label}
          onChange={(e) => update(e.value)}
          checked={check === req.value}
          className="mt-2 mr-2"
        />
        <span>{req.label}</span>
      </div>
    ));
  };

  return (
    <>
      <div className="grid mt-1">
        <StyledCustomCard className="col-12 sm:col:4 md:col-4 lg:col-4">
          <CardWithBackground>
            <StyledLabelBlack>Request Type</StyledLabelBlack>
          </CardWithBackground>
          <CardNoBackground>
            {reqOption(requestOption, request, setRequest)}
          </CardNoBackground>
        </StyledCustomCard>

        <StyledCustomCard className="col-12 sm:col:4 md:col-4 lg:col-4">
          <CardWithBackground>
            <StyledLabelBlack>Market Place</StyledLabelBlack>
          </CardWithBackground>
          <CardNoBackground>
            {reqMarketOption(marketOption, marketPlace, setMarketPlace)}
          </CardNoBackground>
        </StyledCustomCard>

        <StyledCustomCard className="col-12 sm:col:4 md:col-4 lg:col-4">
          <CardWithBackground>
            <StyledLabelBlack>Data Type</StyledLabelBlack>
          </CardWithBackground>
          <CardNoBackground>
            {reqOption(dataTypeOption, dataType, setDataType)}
          </CardNoBackground>
        </StyledCustomCard>
      </div>

      <div className="grid mt-1">
        <div className="col-12 sm:col:6 md:col-6 lg:col-6">
          <div className="text-center">
            <FileUploadComponent
              dataType={dataType}
              request={request}
              marketPlace={marketPlace}
              setActiveTab={setActiveTab}
            />
          </div>
        </div>
        <div className="col-12 sm:col:6 md:col-6 lg:col-6">
          <div>
            <AnimePlayer src={importJson} style={{ height: "240px" }} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Upload;